import toast from "react-hot-toast";

export const toastMessage = (message, type,position) => {
  toast(message, {
    hideProgressBar: true,
    type: type,
    position: position??"bottom-center",
    pauseOnHover: false,
  });
};
